// extracted by mini-css-extract-plugin
export default {"warningModal":"WarningModal_warningModal__mp-f2","warningModal__close":"WarningModal_warningModal__close__pA0Jj"};